export default __webpack_public_path__ + "static/media/bayuh.bc481dd2.png";